import VImg from './index.vue';

export default {
  install: (Vue) => Vue.component('VImg', VImg),
};
